import { CLEAR_SEND_EMAIL, SEND_EMAIL, SEND_EMAIL_FULFILLED, SEND_EMAIL_REJECTED } from './actionTypes';
import { ClearSendEmailAction, SendEmailAction, SendEmailFulfilledAction, SendEmailRejectedAction } from './types';

const clearSendEmail = (): ClearSendEmailAction => ({
  type: CLEAR_SEND_EMAIL,
});

const sendEmail = (id: string, email: string): SendEmailAction => ({
  type: SEND_EMAIL,
  payload: {
    id,
    email,
  },
});

const sendEmailFulfilled = (): SendEmailFulfilledAction => ({
  type: SEND_EMAIL_FULFILLED,
});

const sendEmailRejected = (error: ErrorType): SendEmailRejectedAction => ({
  type: SEND_EMAIL_REJECTED,
  payload: {
    error,
  },
});

export {
  clearSendEmail,
  sendEmail,
  sendEmailFulfilled,
  sendEmailRejected,
};
